import strings from 'localization/strings';

const ownerLevels = {
    basic: {
        color: '#2a4d73'
    },
    standard: {
        color: '#3f7a3a'
    },
    premium: {
        color: '#a32028'
    }
};

Object.keys(ownerLevels).forEach(key => {
    ownerLevels[key].key = key;
});

strings.addLoadCallback(() => {
    Object.keys(ownerLevels).forEach(key => {
        ownerLevels[key].title = strings.ownerLevels[key];
    });
});

export default ownerLevels;
